import { useEffect, RefObject } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const useOntologyAnimation = (
  sectionRef: RefObject<HTMLDivElement | null>,
  arrowRef: RefObject<HTMLImageElement | null>
) => {
  useEffect(() => {
    const section = sectionRef.current;
    const arrow = arrowRef.current;
    if (!section || !arrow) return;

    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Create scroll timeline - arrow moves from 150% to -200% as user scrolls
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        end: "60% top",
        scrub: 1,
      },
    });

    // Animate arrow vertical position
    // Arrow moves from bottom (150%) to far top (-200%) as user scrolls
    // Keep horizontal centering (-50%) while animating vertical position
    tl.fromTo(
      arrow,
      {
        xPercent: -50,
        yPercent: 50,
      },
      {
        xPercent: -50,
        yPercent: -150,
        duration: 1,
        ease: "none",
      }
    );

    return () => {
      tl.kill();
    };
  }, [sectionRef, arrowRef]);
};
